import { render, staticRenderFns } from "./InstructionAccordion.vue?vue&type=template&id=0a8a92cb&scoped=true&"
import script from "./InstructionAccordion.vue?vue&type=script&lang=js&"
export * from "./InstructionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./InstructionAccordion.vue?vue&type=style&index=0&id=0a8a92cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a92cb",
  null
  
)

export default component.exports